import { menuController } from '@ionic/core';
import { IonAlert, IonAvatar, IonButton, IonCard, IonCol, IonContent, IonIcon, IonImg, IonItem, IonLabel, IonMenu, IonPage, IonRow, IonText, useIonViewWillEnter } from '@ionic/react';
import { bagHandleOutline, bookOutline, cardOutline, busOutline, chatbubbleEllipsesOutline, documentTextOutline, downloadOutline, helpCircleOutline, homeOutline, informationCircleOutline, personOutline, walletOutline, mapOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import LoadingContainer from '../../components/loading/LoadingContainer';
import { AuthContext } from '../../context/AuthContext';
import { isWebView, passToWebView } from '../../library/Funcs';
import { HomeAction } from '../../redux/actions/Home';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import './Tab.css';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Tab5 from './Tab5';

interface Props {
    showShop: boolean,
    checkAuth: any,
    initialTabIndex: number,
    alert?: any,
    link?: string,
    linkState?: any
}

const Tab: React.FC<Props> = (props) => {
    const history = useHistory();

    const dispatch = useAppDispatch()

    const { loading, home } = useAppSelector(state => state.home)

    const [shareText, setShareText] = useState("");

    useEffect(() => {
        dispatch(HomeAction())
    }, [dispatch])

    useEffect(() => {
        const homeLoad = async () => {
            if (home != null && !loading) {
                if (isWebView()) {
                    passToWebView('hideStartupLoading', true);
                    setTimeout(() => {
                        passToWebView('hideStartupLoading', true);
                    }, 1000);
                    setTimeout(() => {
                        passToWebView('hideStartupLoading', true);
                    }, 2000);
                    setTimeout(() => {
                        passToWebView('hideStartupLoading', true);
                    }, 3000);
                    setTimeout(() => {
                        passToWebView('hideStartupLoading', true);
                    }, 4000);
                    setTimeout(() => {
                        passToWebView('hideStartupLoading', true);
                    }, 5000);
                    
                    // خواندن مقدار ارتفاع استتوس بار و تنظیم آن برای وب اپ
                    const statusBarHeight = await passToWebView('statusBarHeight', '');
                    document.body.style.setProperty('--status-bar-height', statusBarHeight + "px");
                }

                setShareText(home.initials.messages.share_text);

                window.initials = home.initials;
                window.cartTotal = home.cart?.total;

                if (home.sessionId) {
                    await window.storage.set("sessionId", home.sessionId);
                }
            }
        }

        homeLoad();
    }, [loading])

    useEffect(() => {
        const goToTab = () => {
            if (props.initialTabIndex > 0) {
                changeTabHandler(props.initialTabIndex);
            }
        }

        goToTab();
    }, [props.initialTabIndex])

    useEffect(() => {
        const goToLink = () => {
            if (props.link && props.link?.length > 0) {
                history.push(props.link!, props.linkState)
            }
        }

        goToLink();
    }, [props.link])

    const [tabVisible, setTabVisible] = useState({
        tab1: !props.showShop,
        tab2: props.showShop,
        tab3: false,
        tab4: false,
        tab5: false
    })

    const hideMenuOnItemClick = () => {
        menuController.close("mainMenu")
    }

    const contactHanlder = () => {
        history.push("contact", {"contact": home.initials.contact});
    }

    const changeTabHandler = (index: any) => {
        const tabs = { ...tabVisible }
        tabs.tab1 = false;
        tabs.tab2 = false;
        tabs.tab3 = false;
        tabs.tab4 = false;
        tabs.tab5 = false;

        switch (index) {
            case 1:
                tabs.tab1 = true;
                break;
            case 2:
                tabs.tab2 = true;
                break;
            case 3:
                tabs.tab3 = true;
                break;
            case 4:
                tabs.tab4 = true;
                break;
            case 5:
                tabs.tab5 = true;
                break;
        }

        setTabVisible(tabs)
    }

    const goToShop = () => {
        changeTabHandler(2)
    }

    let tabContent = <>
        <div style={{visibility: tabVisible.tab1 ? "visible" : "hidden"}}>
            <Tab1 banners={home.banners} categories={home.categories} eventsPay={home.eventsPay}
                  activeProjects={home.projects?.activeProjects} finalizedProjects={home.projects?.finalizedProjects}
                  showShop={goToShop}/>
        </div>
        <div style={{visibility: tabVisible.tab2 ? "visible" : "hidden"}}>
            <Tab2 products={home.shop?.products}/>
        </div>
        <div style={{visibility: tabVisible.tab3 ? "visible" : "hidden"}}>
            <Tab3 events={home.tour?.events}/>
        </div>
        <div style={{visibility: tabVisible.tab4 ? "visible" : "hidden"}}>
            <Tab4 posts={home.blog?.posts}/>
        </div>
        <div style={{visibility: tabVisible.tab5 ? "visible" : "hidden"}}>
            <Tab5 profile={home.profile!} checkAuth={props.checkAuth}/>
        </div>

        <IonMenu className="menu" side="start" swipeGesture={false} menuId="mainMenu" contentId="menu-content">
            <IonContent color="secondry">
                <IonRow className="welcome">
                    <IonAvatar className="avatar"><IonImg src="/assets/images/logo_original.png"></IonImg></IonAvatar>
                    <IonText className="text">به نذرطبیعت خوش آمدید</IonText>
                </IonRow>
                {/* <IonItem lines="none" button onClick={hideMenuOnItemClick} routerLink="/events">
                    <IonIcon icon={mapOutline}/><IonText>سفرها</IonText>
                </IonItem> */}

                {isWebView() ?
                    <IonItem lines="none" button onClick={() => {
                        passToWebView('shareText', 'معرفی به دوستان', shareText);
                        hideMenuOnItemClick()
                    }}>
                        <IonIcon icon={documentTextOutline}/><IonText>معرفی به دوستان</IonText>
                    </IonItem>
                    : null}

                <IonItem lines="none" button onClick={hideMenuOnItemClick} routerLink="/fund">
                    <IonIcon icon={walletOutline}/><IonText>صندوق ذخیره</IonText>
                </IonItem>

                <AuthContext.Consumer>
                    {
                        (context) => {
                            return !context.auth ?
                                <IonItem lines="none" button onClick={hideMenuOnItemClick} routerLink={"pay"}>
                                    <IonIcon icon={cardOutline}/><IonText>واریز و پرداخت</IonText>
                                </IonItem> : null
                        }
                    }
                </AuthContext.Consumer>

                <IonItem lines="none" button onClick={hideMenuOnItemClick} routerLink="/map">
                    <IonIcon icon={documentTextOutline}/><IonText>نقشه پروژه ها</IonText>
                </IonItem>
                <IonItem lines="none" button onClick={hideMenuOnItemClick} routerLink="/page/privacy">
                    <IonIcon icon={documentTextOutline}/><IonText>قوانین و مقررات</IonText>
                </IonItem>
                <IonItem lines="none" button onClick={hideMenuOnItemClick} routerLink="/page/faq">
                    <IonIcon icon={helpCircleOutline}/><IonText>سوالات متداول</IonText>
                </IonItem>
                <IonItem lines="none" button onClick={hideMenuOnItemClick} routerLink="/page/about">
                    <IonIcon icon={informationCircleOutline}/><IonText>درباره ما</IonText>
                </IonItem>
                <IonItem lines="none" button onClick={() => {
                    hideMenuOnItemClick();
                    contactHanlder()
                }}>
                    <IonIcon icon={chatbubbleEllipsesOutline}/><IonText>ارتباط با ما</IonText>
                </IonItem>
            </IonContent>
        </IonMenu>

        <div id="menu-content"></div>

        <IonCard className="tab-nav">
            <IonRow>
                <IonCol  className="ion-no-padding">
                    <IonButton className={tabVisible.tab1 ? "active" : ""} onClick={e => changeTabHandler(1)}>
                        <IonIcon icon={homeOutline}/>
                        <IonLabel>خانه</IonLabel>
                    </IonButton>
                </IonCol>
                <IonCol className="ion-no-padding">
                    <IonButton className={tabVisible.tab2 ? "active" : ""} onClick={e => changeTabHandler(2)}>
                        <IonIcon icon={bagHandleOutline}/>
                        <IonLabel>فروشگاه</IonLabel>
                    </IonButton>
                </IonCol>
                <IonCol className="ion-no-padding">
                    <IonButton className={tabVisible.tab3 ? "active" : ""} onClick={e => changeTabHandler(3)}>
                        <IonIcon icon={mapOutline}/>
                        <IonLabel>سفرها</IonLabel>
                    </IonButton>
                </IonCol>
                <IonCol className="ion-no-padding">
                    <IonButton className={tabVisible.tab4 ? "active" : ""} onClick={e => changeTabHandler(4)}>
                        <IonIcon icon={bookOutline}/>
                        <IonLabel>وبلاگ</IonLabel>
                    </IonButton>
                </IonCol>
                <IonCol className="ion-no-padding">
                    <IonButton className={tabVisible.tab5 ? "active" : ""} onClick={e => changeTabHandler(5)}>
                        <IonIcon icon={personOutline}/>
                        <IonLabel>حساب من</IonLabel>
                    </IonButton>
                </IonCol>
            </IonRow>
        </IonCard>

        <IonAlert
            isOpen={props.alert.show}
            header={props.alert.title}
            message={props.alert.message}
            buttons={[
                {
                    text: 'متوجه شدم',
                    handler: () => {
                    }
                }
            ]}
        />
    </>

    if (isWebView()) {
        return tabContent
    } else {
        return <LoadingContainer loading={loading} startup>
        {tabContent}
        </LoadingContainer>
    }
}

export default Tab